import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Hash: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '4', x2: '20', y1: '9', y2: '9' }],
    ['line', { x1: '4', x2: '20', y1: '15', y2: '15' }],
    ['line', { x1: '10', x2: '8', y1: '3', y2: '21' }],
    ['line', { x1: '16', x2: '14', y1: '3', y2: '21' }],
  ],
];

export default Hash;
